<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true">
    <path
      fill="currentColor"
      d="M.4 5.7c.3-.3.7-.4 1.1-.4.4 0 .8.2 1.1.4l9.4 9.4 9.4-9.4c.1-.1.3-.3.5-.3s.4-.1.6-.1c.2 0 .4 0 .6.1.2.1.4.2.5.3.1.1.3.3.3.5.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.3.5L13.1 18.3c-.3.3-.7.4-1.1.4-.4 0-.8-.2-1.1-.4L.4 7.8c-.2-.3-.4-.6-.4-1s.2-.8.4-1.1z"
    />
  </svg>
</template>
